export const COOKIE_CONSENT_STORAGE_KEY = 'colobongo_cookie_consent_v1';
export const LEGACY_PRIVACY_ACK_KEY = 'colobongo_privacy_acknowledged';

export const COOKIE_CONSENT_EVENTS = {
  OPEN_PREFERENCES: 'colobongo:open-cookie-preferences',
  UPDATED: 'colobongo:cookie-consent-updated'
};

function parseConsent(rawValue) {
  if (!rawValue) return null;

  try {
    const parsed = JSON.parse(rawValue);
    if (!parsed || (parsed.choice !== 'accepted' && parsed.choice !== 'rejected')) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function dispatchCookieEvent(name, detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export function getCookieConsent() {
  if (typeof window === 'undefined') return null;

  const parsed = parseConsent(localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY));
  if (parsed) return parsed;

  const legacy = localStorage.getItem(LEGACY_PRIVACY_ACK_KEY);
  if (!legacy) return null;

  const migrated = {
    choice: 'accepted',
    updatedAt: new Date().toISOString(),
    source: 'legacy'
  };

  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(migrated));
  return migrated;
}

export function hasCookieConsentChoice() {
  return !!getCookieConsent();
}

export function setCookieConsent(choice, source = 'banner') {
  if (typeof window === 'undefined') return;
  if (choice !== 'accepted' && choice !== 'rejected') return;

  const payload = {
    choice,
    updatedAt: new Date().toISOString(),
    source
  };

  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(payload));

  if (choice === 'accepted') {
    localStorage.setItem(
      LEGACY_PRIVACY_ACK_KEY,
      JSON.stringify({
        acknowledged: true,
        timestamp: payload.updatedAt,
        version: '2.0'
      })
    );
  } else {
    localStorage.removeItem(LEGACY_PRIVACY_ACK_KEY);
  }

  dispatchCookieEvent(COOKIE_CONSENT_EVENTS.UPDATED, payload);
}

export function clearCookieConsent() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(COOKIE_CONSENT_STORAGE_KEY);
  localStorage.removeItem(LEGACY_PRIVACY_ACK_KEY);
  dispatchCookieEvent(COOKIE_CONSENT_EVENTS.UPDATED, { choice: null });
}

export function openCookiePreferences() {
  dispatchCookieEvent(COOKIE_CONSENT_EVENTS.OPEN_PREFERENCES);
}

export function isNonEssentialCookiesAllowed() {
  const consent = getCookieConsent();
  return consent?.choice === 'accepted';
}

